export var GOOGLE_IMA_DAI_PLUGIN_ID="@dicetechnology/doris-plugin-google-ima-dai";